import Card from '@mui/material/Card';
//import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';


const StyledCard = styled((props) => (
  <Card {...props} />
))(({ theme }) => ({

  background: 'transparent',
  borderColor: 'transparent',
  paddingTop: '2rem',
   
  [theme.breakpoints.up('xs')]: {
      width: 440,
      height: 'auto',
    },
  [theme.breakpoints.up('sm')]: {
      width: 440,
      height: 'auto',
    },
  [theme.breakpoints.up('md')]: {
      width: 440,
      height: 'auto',
   },
   [theme.breakpoints.up('lg')]: {
      width: 520,
      height: 'auto',
    },
  [theme.breakpoints.up('xl')]: {
    width: 540,
    height: 'auto',
    },

}));


export default function CardTransparent(props) {
  
  const { content } = props

return(
<>

<StyledCard variant="outlined" >
      { content } 
</StyledCard>
</>
)
}

